import axios, { AxiosResponse } from 'axios';

const zmenaEmailuApi = (password: string, email: string, lang: string) =>
    axios({
        method: 'POST',
        url: 'Portal/ZmenaEmailu',
        data: {
            password,
            email,
            lang
        }
    }).then((resp: AxiosResponse<{ code: 'OK' | 'DUPLICITA' | 'AUTENTIZACE' }>) => resp.data);

export default zmenaEmailuApi;
